if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      observer = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        this.initializeRecommendations(this.dataset.productId);
      }

      initializeRecommendations(productId) {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.loadRecommendations(productId);
          },
          /* ClassyTea (2026-09-23): start 2500px early (was 400px) so the row lands while it is still far off-screen;
             a late arrival pushed the footer while visible (CLS). */
          { rootMargin: '0px 0px 2500px 0px' }
        );
        this.observer.observe(this);
      }

      loadRecommendations(productId) {
        fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations?.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              const fade = this.querySelectorAll('[data-animate-fade]');
              fade.forEach((element) => element.classList.remove('faded-out'));
            } else {
              this.style.minHeight = '0'; /* ClassyTea: nothing to show, give the reserved space back */
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
